import { locale, t, type MessageKey } from "../i18n";
export interface EmojiEntry {
  emoji: string;
  label: string;
  search: string;
  category: number;
}
/** The picker's groups; names come from the catalog, in the member's language. */
export const emojiCategories = [
  { key: "smileys", icon: "smile" },
  { key: "animals", icon: "PawPrint" },
  { key: "food", icon: "Coffee" },
  { key: "activities", icon: "Volleyball" },
  { key: "travel", icon: "Car" },
  { key: "objects", icon: "lightbulb" },
  { key: "symbols", icon: "Hash" },
  { key: "flags", icon: "Flag" },
].map((c) => ({
  ...c,
  get name() {
    return t(`emoji.category.${c.key}` as MessageKey);
  },
}));
export function normalizeEmojiSearch(value: string) {
  return value
    .normalize("NFD")
    .replace(/[\u0300-\u036f\uFE0F]/g, "")
    .toLowerCase()
    .trim();
}
/** Labels and search tags per interface language (generated from Emojibase). */
const DATA: Record<string, () => Promise<{ default: unknown }>> = {
  "pt-BR": () => import("./emoji-data.pt-BR.json"),
  es: () => import("./emoji-data.es.json"),
  en: () => import("./emoji-data.en.json"),
};
let catalog: Promise<EmojiEntry[]> | undefined;
let catalogLocale = "";
export function loadEmojis() {
  if (catalogLocale !== locale.value) {
    catalog = undefined;
    catalogLocale = locale.value;
  }
  return (catalog ||= (DATA[locale.value] ?? DATA["pt-BR"]!)()
    .then(({ default: rows }) =>
      (rows as [string, string, string, number][]).map(
        ([emoji, label, tags, category]) => ({
          emoji,
          label,
          category,
          search: normalizeEmojiSearch(
            `${emoji} ${label} ${tags} ${emojiCategories[category].name}`,
          ),
        }),
      ),
    )
    .catch((error) => {
      catalog = undefined;
      throw error;
    }));
}
export function filterEmojis(
  entries: EmojiEntry[],
  query: string,
  category: number,
) {
  const words = normalizeEmojiSearch(query).split(/\s+/).filter(Boolean);
  return entries.filter((entry) =>
    words.length
      ? words.every((word) => entry.search.includes(word))
      : entry.category === category,
  );
}
